import React, { useState, useEffect, useCallback, useMemo, useRef, Children } from 'react';
import {EuiFlexGroup, EuiButton, EuiSpacer, EuiFlexItem, EuiFormRow, EuiPanel, EuiFieldNumber, EuiSwitch, EuiButtonIcon, EuiIcon, EuiLoadingSpinner, EuiFilterGroup, EuiFilterButton} from '@elastic/eui';
import moment from 'moment';
import { SelectorInformesContainer as SelectorInformes } from '../../../../components/Selectores/Informes/container';
import { SelectorPeriodosContainer as SelectorPeriodos} from '../../../../components/Selectores/Periodos/container';
import { SelectorMonedasContainer as SelectorMonedas} from '../../../../components/Selectores/Monedas/container';
import { SelectorEjercicioContainer as SelectorEjercicio} from '../../../../components/Selectores/Ejercicio/container';
import { GridResultsScreen } from '../../../../components/GridInformes/GridResultsScreen';
import { SumarigramaContainer } from '../../../Consultas/Sumarigrama/Screen';
import './styles.css';
import { TablaInforme } from '../../../../components/TablaInforme';
import { GraficoInforme } from '../../../../components/GraficoInforme';
import { GraficosBarras } from '../../../../components/GraficosBarras';
import html2canvas from 'html2canvas';
import {openPDF} from '../../../../../../shared/Components/Pdf';
import informePdf from '../../../../components/Report'
import { TITLESREPORT } from './constant';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import logopdf from '../../../../../../shared/Icons/logoInfraestructura.png';
import { PeriodoDescripciones } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';


interface dataRequest {año:number, periodo:number, IdTipoInforme: string, MonedaCorriente: boolean, moneda: string, IdCentroDesde: string, SumarigramaReunion: boolean}

interface Props {
  onFilter(data: dataRequest): void;
  data: any;
  isLoading: boolean;
}

const toDataUrl = async(file:any,callback?:any) =>{
  var xhr = new XMLHttpRequest();
     xhr.responseType = 'blob';
     xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
     callback(reader.result);
  }
    reader.readAsDataURL(xhr.response);
 };
  xhr.open('GET', file);
  xhr.send();
  }

export const SeleccionInformesScreen = (props: Props) => {

  let { onFilter, data, isLoading } = props;
  const ref:any = useRef();
  
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
  const _tiposMoneda = [{label:'Moneda Corriente',value:'MCR'}, {label:'Moneda Constante',value:'MCT'}]

  let [año, setAño] = useState<number>(_año);
  let [periodo, setPeriodo] = useState<PeriodoDescripciones>({idTipoPeriodo: 0,tipoPeriodo: ''});
  let [informe, setInforme] = useState<any>(undefined);
  let [versionInforme, setversionInforme] = useState<any>(undefined);
  let [moneda, setMoneda] = useState<any>('EUR');
  let [showGrid, setShowGrid] = useState<boolean>(false);
  let [idCentro, setIdCentro] = useState<any>(undefined);
  let [toogle, setToogle] = useState(false);
  let [isPrinting, setIsPrinting] = useState<boolean>(false);
  let [tipoCambioMoneda, setTipoCambioMoneda] = useState(_tiposMoneda[0].value)
  let [sumReunion, setSumReunion] = useState<boolean>(true);

  let logo:any = undefined;

  const onChangePeriodo = (value:any) => {
    setPeriodo(value)
  }

  const onInformeChange = (value: any) => {
    if(value != undefined){
      setInforme(value.idTipoInforme);
      setversionInforme(value.idVersion);
    }
  }

  const onRefresh = () =>{
    onFilter(getRequesData());
  }

  const getRequesData = () => {
    const reqdata : dataRequest = {
      año : año, periodo: periodo.idTipoPeriodo, IdTipoInforme: informe, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: moneda[0].value, IdCentroDesde: idCentro, SumarigramaReunion: sumReunion
    }
    return (
      reqdata
    )
  }

  const onClickToogle = () =>{
    setToogle(!toogle)
  }

  const getFilter = useMemo(()=> {return{'año':año, 'periodo':periodo.idTipoPeriodo, 'idTipoContenido':informe}},[año,periodo,informe])

  const onClickCentro = (id:string)=> setIdCentro(id)

  const fnIsLoading = (pisLoading: boolean) =>{
    if(pisLoading)
      return <EuiLoadingSpinner size="xl" />
    else
      return <EuiButtonIcon display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()}/>
  }


  const onClickPrint = async() => {
        
    var obj:any = document.getElementById('AreaImprimirPDF') ?? document.createElement("div");

    obj && (obj.parentElement.scrollTop = 0);

    await toDataUrl(logopdf,(base64Image:any)=> {logo = base64Image})
    
      html2canvas(obj, {
          height: obj.scrollHeight,
          width: obj.scrollWidth,
          scale: 3,
          backgroundColor: null,
          logging: false,
          
        }).then((canvas:any) => {
              var vImg = canvas.toDataURL();
              var vTitle = getTitle;
              openPDF(informePdf(vImg, informe, vTitle, logo, (año + ' - ' + periodo.tipoPeriodo)));
              setIsPrinting(false);
        });

}

const onImageDownload = async() => {

  //var obj:any = document.getElementById('AreaImprimirPDF') ?? document.createElement("div");
  //var objTitle = document.getElementById('AreaImprimirIMG');
  var objTable:any = document.getElementById('AreaImprimirPDF') ?? document.createElement("div");
  var objTitle = document.getElementById('AreaImprimirIMG') ?? document.createElement("div");
  let newDiv = document.createElement("div");

  objTable && (objTable.parentElement.scrollTop = 0);
  let titleDiv = document.createElement("h1")
  titleDiv.innerText = objTitle.innerText
  titleDiv.classList.add('titleReportIMG')
  var objTableClone = objTable.cloneNode(true)
  let DivTitle = document.createElement("div");
    DivTitle.append(titleDiv);
    newDiv.append(DivTitle);
    objTableClone.style ="";
    newDiv.append(objTableClone);
  // newDiv.append(objTableClone);
  //document.body.appendChild(newDiv);
  objTable.append(newDiv)
  var vHeight = ((objTable.scrollHeight / 2) + 50);
  newDiv.setAttribute("style","width:" + objTable.scrollWidth + "px;height:" +  vHeight + "px");

  // var objTitlesTable:any = objTableClone.children[0]
  // objTitlesTable.prepend(titleDiv)

  html2canvas(newDiv, {
    height: vHeight,
    width: objTable.scrollWidth,
    scale: 3,
    backgroundColor: "white",
    logging: false,
    
  }).then((canvas) => {
    var vImg = canvas.toDataURL(); 
    const a = window.document.createElement("a");
    a.href = vImg; //window.URL.createObjectURL(vImg);
    a.download = getTitle + ".jpg";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    objTable.removeChild(newDiv)
    //document.body.removeChild(newDiv);
  });
}
  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const onChangeTipoCambioMoneda = (value:string)=>{
    setTipoCambioMoneda(value)
  }

  const getDataDisplay = useMemo(()=>{
    if(showGrid){
      return(<GridResultsScreen
        data={data}
        selector={false}
        menu={false}
        ref={ref}
        informe={informe}
      />)
    }else{
      if(informe == 'GREVOL') return <GraficoInforme data={data} tipo={informe} año={año} periodo={periodo.idTipoPeriodo} moneda={moneda?moneda[0].value:'EUR'}/>
      else if(informe == 'GRPRPOBJ' || informe == 'GRTEND'|| informe == 'GRREAL') return <GraficosBarras data={data} tipo={informe} año={año} periodo={periodo.idTipoPeriodo} moneda={moneda?moneda[0].value:'EUR'}/>
      else return <TablaInforme data={data} tipo={informe} idVersion={versionInforme} año={año} moneda={moneda?moneda[0].value:'EUR'}/>
    }
  },[showGrid,data])

  const getNombreCentro = () => {
    let dataFilter=[];

    dataFilter = (data && data.filter((d:any)=> d.idCentro === idCentro))

    if(dataFilter.length>0){return dataFilter[0].centro}else{return ''}
  }

  const centro = useMemo(()=> data && data[0] ?  `${idCentro} - ${getNombreCentro()}` : '',[data])

  const getTitle = useMemo(()=>{
    if(data && data.length>0){
      switch (informe) {
            case 'TENDVEH':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).TENDVEH
            case 'PROPOBJVEH':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).PROPOBJVEH
            case 'PROOBJTEND':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).PROOBJTEND
            case 'OBJREAL':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).OBJREAL
            case 'TENDOBJ':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).TENDOBJ
            case 'GREVOL':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).GREVOL
            case 'GRPRPOBJ':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).GRPRPOBJ
            case 'GRTEND':
              return TITLESREPORT(centro,año, periodo.idTipoPeriodo).GRTEND
            default: return ''
      }
    }
  },[data,periodo])

  const Actions: Action[] = useMemo(()=>[
    {handle:onExport,text:"Exportar",size:"s", isDisabled:!showGrid},
    {handle:onClickPrint, text:"Imprimir", size: "s", isDisabled: data.length == 0 || showGrid},
    {handle:onImageDownload, text:"Descargar Imagen", size: "s", isDisabled: data.length == 0 || showGrid}
  ],[onExport, onClickPrint, onImageDownload, showGrid, data])

  return (
    <>
      <EuiFlexGroup gutterSize='none' style={{height:'100%'}} className={(toogle ? "collapsePanel collapsed" : "collapsePanel")}>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup direction='column' gutterSize='s' style={{height:'100%'}}>
            <EuiFlexItem grow={false}>
                {/* <EuiFormRow> */}
                  <SelectorEjercicio fullWidth value={año} onChange={(e:any) => setAño(e)} />
                {/* </EuiFormRow> */}
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                {/* <EuiFormRow> */}
                  <SelectorPeriodos fullWidth valueOfSelected={periodo.idTipoPeriodo} onChange={(value: any) => onChangePeriodo(value)} soloCerrados={true} año={año} getText />
                {/* </EuiFormRow> */}
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                {/* <EuiFormRow> */}
                  <SelectorInformes fullWidth valueOfSelected={informe} onChange={onInformeChange} año={año} periodo={periodo.idTipoPeriodo} conVersion={true} />
                {/* </EuiFormRow> */}
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                {/* <EuiFormRow> */}
                  <EuiPanel className={showGrid ? 'panelSwitchCheck' : 'panelSwitchUnCheck'}>
                    <EuiSwitch label={'Formato Tabla'} checked={showGrid} onChange={(e)=>setShowGrid(!showGrid)} />
                  </EuiPanel>
            </EuiFlexItem>

            <EuiFlexItem grow={false}>
                {/* <EuiFormRow> */}
                  <EuiPanel className={sumReunion ? 'panelSwitchCheck' : 'panelSwitchUnCheck'}>
                    <EuiSwitch label={'Sumarigrama Reunión'} checked={sumReunion} onChange={(e)=>setSumReunion(!sumReunion)} />
                  </EuiPanel>
            </EuiFlexItem>
                {/* </EuiFormRow> */}
            <EuiFlexItem style={{overflow:'hidden'}}>

                {/* <EuiFormRow style={{height:'100%',border:'none'}}> */}
                  <SumarigramaContainer menu={true} onlySearch={true} filter={getFilter} onClickNode={onClickCentro} style={{overflow:'auto',height: '100%', border:'none'}}/>
                {/* </EuiFormRow> */}
            </EuiFlexItem>
            </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem className='tooglebtn' grow={false} onClick={onClickToogle}>
              <EuiIcon type={toogle ? "arrowRight" : "arrowLeft"} size="l" onClick={onClickToogle}/>
            </EuiFlexItem>
        <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
          <EuiFlexGroup alignItems='baseline'>
            <EuiFlexItem style={{flexGrow:0.3}}>
                <SelectorMonedas selectedOptions={moneda} onChange={(value:any) => setMoneda(value)}/>
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiFlexGroup alignItems='center' >
                <EuiFlexItem grow={false}>
                  <EuiFilterGroup>
                    <EuiFilterButton
                      grow={false}
                      hasActiveFilters={tipoCambioMoneda===_tiposMoneda[0].value}
                      onClick={()=>onChangeTipoCambioMoneda(_tiposMoneda[0].value)}>
                      {_tiposMoneda[0].label}
                    </EuiFilterButton>
                    <EuiFilterButton
                      grow={false}
                      hasActiveFilters={tipoCambioMoneda===_tiposMoneda[1].value}
                      onClick={()=>onChangeTipoCambioMoneda(_tiposMoneda[1].value)}>
                        {_tiposMoneda[1].label}
                    </EuiFilterButton>
                  </EuiFilterGroup>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  {/* <EuiButtonIcon display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()}/> */}
                  {fnIsLoading(isLoading)}
                </EuiFlexItem>
                {/* <EuiFlexItem grow={false}>
                  {fnIsPrinting(isPrinting, data.length > 0)} */}
                <EuiFlexItem>
                  <Menu actions={Actions}/>
                </EuiFlexItem>
              </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
          {/* <EuiSpacer size="m"/> */}
            <EuiFlexGroup style={{height:'95%', flexDirection:'column'}}>
              <EuiFlexItem grow={false} style={{marginBottom:'0'}}>
                <div id='AreaImprimirIMG' className='titleReport'>{getTitle}</div>
              </EuiFlexItem>
              <EuiFlexItem style={{ overflowX:'auto', overflowY:'auto'}}>
                {getDataDisplay}
              </EuiFlexItem>
            </EuiFlexGroup> 
          </EuiFlexItem>
          </EuiFlexGroup>
    </>
  );
};

export default SeleccionInformesScreen;
